/**
 * İzin anahtarları — backend'deki katalogla (`security/permission/Permission`) aynı liste.
 *
 * Arayüz rolden değil izinden karar verir: bir sekme, ekran ya da buton yalnız ilgili izin
 * varsa görünür. İzinlerin Türkçe adları ve açıklamaları sunucudan gelir (`GET /api/permissions`);
 * burada yalnız anahtarlar ve sekme eşlemesi var, böylece web ve mobil aynı kararı verir.
 */
export const PROJECT_PERMISSIONS = [
  'notes.view', 'notes.edit', 'notes.delete',
  'files.view', 'files.edit', 'files.delete',
  'folders.manage', 'tags.manage',
  'tasks.view', 'tasks.edit',
  'vault.view', 'vault.edit',
  'deploy.view', 'deploy.run', 'deploy.manage',
  'offers.view', 'offers.edit',
  'comments.write', 'comments.moderate', 'share.manage',
  'members.view', 'members.manage',
  'activity.view',
  'tests.view', 'tests.run', 'tests.manage',
  'project.settings', 'project.delete',
] as const

export const SYSTEM_PERMISSIONS = [
  'project.create',
  'admin.users', 'admin.teams', 'admin.roles', 'admin.audit', 'admin.stats', 'admin.stages', 'admin.mail',
  'admin.projects.members',
] as const

export type ProjectPermission = (typeof PROJECT_PERMISSIONS)[number]
export type SystemPermission = (typeof SYSTEM_PERMISSIONS)[number]
export type PermissionKey = ProjectPermission | SystemPermission

/** Proje sekmeleri ve onları açan izin; sıra arayüzdeki sıradır. */
export const PROJECT_TABS = [
  { key: 'notlar', permission: 'notes.view' },
  { key: 'dosyalar', permission: 'files.view' },
  { key: 'gorevler', permission: 'tasks.view' },
  { key: 'kasa', permission: 'vault.view' },
  // Deploy'un kendi izinleri var (backend DeployAccess): deploy.view izler, deploy.run
  // çalıştırır ve durdurur, deploy.manage kurulum yapar.
  { key: 'deploy', permission: 'deploy.view' },
  { key: 'teklifler', permission: 'offers.view' },
  { key: 'uyeler', permission: 'members.view' },
  { key: 'hareketler', permission: 'activity.view' },
  { key: 'testler', permission: 'tests.view' },
  { key: 'ayarlar', permission: 'project.settings' },
] as const satisfies readonly { key: string; permission: ProjectPermission }[]

export type ProjectTabKey = (typeof PROJECT_TABS)[number]['key']

/** İzin listesinde anahtar var mı? (null/eksik liste = izin yok.) */
export function hasPermission(permissions: readonly string[] | null | undefined, key: PermissionKey): boolean {
  return !!permissions && permissions.includes(key)
}

/** Kullanıcının bu projede görebildiği sekmeler, arayüz sırasıyla. */
export function visibleProjectTabs(permissions: readonly string[] | null | undefined): ProjectTabKey[] {
  return PROJECT_TABS.filter((t) => hasPermission(permissions, t.permission)).map((t) => t.key)
}
